import { render, staticRenderFns } from "./remover-produto.vue?vue&type=template&id=1a940794&scoped=true&"
import script from "./remover-produto.vue?vue&type=script&lang=js&"
export * from "./remover-produto.vue?vue&type=script&lang=js&"
import style0 from "./remover-produto.vue?vue&type=style&index=0&id=1a940794&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a940794",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a940794')) {
      api.createRecord('1a940794', component.options)
    } else {
      api.reload('1a940794', component.options)
    }
    module.hot.accept("./remover-produto.vue?vue&type=template&id=1a940794&scoped=true&", function () {
      api.rerender('1a940794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/modal/remover-produto/remover-produto.vue"
export default component.exports